/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, useCallback, useRef } from "react";
import { Button } from "antd";
import { _asyncPost, _get, _post } from "../../Utils/Helper";
import PDFTEMPLATE from "./components/PDFTEMPLATE";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
import { RootState } from "../../../redux/reducers";
import { useSelector } from "react-redux";
// import { Table } from "react-bootstrap";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import {
  acadamicTerms,
} from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import MergedPDFTemplate from "./components/MergedPDFTemplate";

// const { Option } = Select;

export interface SubjectDetail {
  name: string;
  caScore?: string;
  examScore?: string;
  assignmentScore?: string;
  grade?: string;
  section?: string;
  type?: string;
  remark?: string;
  mark_by?: string;
}

interface StudentData {
  student_name: string;
  admission_no: string;
  class_name: string;
  academic_year: string;
  term: string;
  total_score: number;
  remark: string;
  result: string;
  position: string;
  records?: SubjectDetail[]; // Update the records property to match the expected type
}

const GradeReport = () => {
  // const routes = all_routes;
  const { classes, school, academic_calendar, user } = useSelector((state: RootState) => state.auth);
  // const [, setClasses] = useState<any[]>([]);
  const [gradings, setGradeSetups] = useState<any[]>([]);
  // const [className, setClassName] = useState<string | undefined>(undefined);
  // const [admissionNo, setAdmissionNo] = useState<string | undefined>(undefined);
  const [studentData, setStudentData] = useState<StudentData[]>([]);
  const [academicCalendar, setAcademicCalendar] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({ term: "", class_name:"", class_code: "" });
  const pdfLinkRef = useRef<any>(null);

  const getGradeSetups = useCallback(() => {
    _get(
      "grade-setup?query_type=select-all",
      (res) => {
        if (res.success && res.data && res.data.length) {
          setGradeSetups(res.data);
        }
      },
      (err) => {
        console.error("Error fetching calendar:", err);
      }
    );
    _get(
      "academic-calendar?query_type=select-all",
      (res) => {
        if (res.success && res.data && res.data.length) {
          setAcademicCalendar(res.data);
        }
      },
      (err) => {
        console.error("Error fetching calendar:", err);
      }
    );
  }, []);

  const fetchStudentData = async () => {
    setIsLoading(true);
  
    try {
      interface ResponseType {
        results: StudentData[];
      }

      const response: ResponseType = await _asyncPost(`get_class_results`, {
        query_type: "Select Joined Class Reports",
        class_name: form.class_code,
        term: form.term,
        school_id: school.school_id,
        academic_year:
          Array.isArray(academic_calendar) && academic_calendar.length > 0
            ? academic_calendar[0].academic_year
            : "",
      });
  
      if (response && response.results) {
        let students = response.results;
  
        // Fetch student details in parallel
        const studentDetailsPromises = students.map(async (student) => {
          interface StudentDetailResponse {
            results: any[];
          }

          const studentDetailResponse: StudentDetailResponse = await _asyncPost(`get_class_results`, {
            query_type: "Select Student Draft",
            admission_no: student.admission_no,
            class_name: form.class_name,
            term: form.term,
            academic_year:
            Array.isArray(academic_calendar) && academic_calendar.length > 0
              ? academic_calendar[0].academic_year
              : "",
            school_id: user.school_id,
          });
  
          // Merge details into student record
          return {
            ...student,
            records: (studentDetailResponse?.results || []) as SubjectDetail[], // Explicitly cast to SubjectDetail[]
          };
        });
  
        // Wait for all student details to resolve
        const updatedStudents = await Promise.all(studentDetailsPromises);
  
        // Update state with new student data
        setStudentData(updatedStudents);
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    getGradeSetups();
  }, [getGradeSetups]);

  interface GroupedStudentData {
    student: StudentData;
    scores: StudentData[];
  }

  const transformStudentDataToGroups = (
    data: StudentData[]
  ): GroupedStudentData[] => {
    // Group by a unique key (student_name and admission_no)
    const groups = data.reduce((acc, item) => {
      const key = `${item.student_name.trim()}: ${item.admission_no}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as Record<string, StudentData[]>);

    // Convert the groups object to an array with separate student and scores properties.
    return Object.values(groups).map((group) => ({
      student: group[0], // common data from the first record
      scores: group, // all records (subjects, etc.)
    }));
  };
  // Usage:
  const groupsArray = transformStudentDataToGroups(studentData);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Grade Report</h3>

              <span className="page-subheading">
                Generate and download student grade reports
              </span>
            </div>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Exam</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Student Exam Report
                </li>
              </ol>
            </nav>
          </div>
          {/* <div style={{ height: "70vh" }}>
            <PDFViewer width="100%" height="100%">
              <PDFTEMPLATE student={studentData} school={school} grading={[]} scores={[]} />
            </PDFViewer>
          </div> */}
          <div className="row">
            {/* {JSON.stringify(classes)} */}
            <div className="col-md-3">
              <label>Select Class</label>
              <CommonSelect
                placeholder="Select Class"
                options={classes.map((classItem) => ({
                  label: classItem.class_name,
                  value: classItem.class_code,
                }))}
                defaultValue={{
                  label: form.class_name || "",
                  value: form.class_code || "",
                }}
                handleChange={(newValue: SingleValue<Option>) => {
                  setForm((p)=>({...p, class_name:newValue?.label || "", class_code:newValue?.value || ""}));
                }}
              />
            </div>
            <div className="col-md-3">
              <label>Select Term</label>
              <CommonSelect
                placeholder="Select Term"
                className="select"
                options={acadamicTerms}
                defaultValue={{
                  label: form.term,
                  value: form.term,
                }}
                handleChange ={(newValue: SingleValue<Option>) =>
                  setForm((prev) => ({
                    ...prev,
                    term: newValue ? newValue.value : "",
                  }))
                }
              />
            </div>
            <div className="col-md-3 pt-4">
              <Button
                type="primary"
                onClick={fetchStudentData}
                loading={isLoading}
              >
                Generate Result
              </Button>
            </div>
            <div className="col-md-3 pt-4">
              {/* {JSON.stringify(school)} */}
              {studentData.length > 0 && (
                <PDFDownloadLink
                  document={
                    <MergedPDFTemplate
                      groups={groupsArray}
                      school={school}
                      grading={gradings}
                    />
                  }
                  fileName={`${form.class_name} - ${form.term} - REPORT.pdf`}
                  ref={pdfLinkRef}
                >
                  <Button className="btn btn-success">
                    Download All Reports PDF
                  </Button>
                </PDFDownloadLink>
              )}{" "}
            </div>
          </div>
          <table className="table mt-4">
            <thead>
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Admission No.</th>
                <th>Position</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {groupsArray && groupsArray.length > 0 ? (
                groupsArray.map((group, index) => (
                  <tr
                    key={`${group.student.student_name}:${group.student.admission_no}`}
                  >
                    <td>{index + 1}</td>
                    <td>{group.student.student_name}</td>
                    <td>{group.student.admission_no}</td>
                    <td>
                     {/* <pre> {JSON.stringify(group?.student)}</pre> */}
                     <td>{group.student.position}</td>
                    </td>
                    <td>
                      {JSON.stringify(academicCalendar)}
                      {/* <PDFDownloadLink
                        document={
                          <PDFTEMPLATE
                            student={group.student}
                            scores={group.scores}
                            school={school}
                            grading={gradings}
                          />
                        }
                        fileName={`${group.student.student_name
                          .replace(/\s+/g, "_")
                          .toLowerCase()}-report.pdf`}
                        ref={pdfLinkRef}
                      >
                        <a className="pdf-download-button">Download PDF</a>
                      </PDFDownloadLink> */}
                       <PDFViewer width="100%" height="100%">

                      <PDFTEMPLATE
                            student={group.student}
                            scores={group.student.records || []}
                            school={school}
                            grading={gradings}
                            academic_calendar={academicCalendar || []}
                            // academic_calendar={academic_calendar || []}
                          />
                      </PDFViewer>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No records available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GradeReport;
